import Service from "../DepartmentService";

function GetByDepartmentId() {
    return Service.get('AIAgent');
}

const AIAgentService = {
    GetByDepartmentId
};

export default AIAgentService;
